import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/app/[locale]/(playground)/playground/iframe_view.tsx");
